<template>
  <div class="mt-4">
    <b-table 
      :items="units" 
      :fields="[
        // Unit nr. (Unitkenmerk)
        // Adres (Adres)
        // Preventief onderhoud (PreventiefOnderhoud)
        // Correctief onderhoud (CorrectiefOnderhoud)
        // Beheerskosten (Beheerskosten)
        // Spreekluister (Spreekluister)
        // PLOH {Jaar} (PLOH)
        // Correctieve reservering (CorrectieveReservering)
        // GSM Spreekluister (GSM) -- Uit PLOH
        // Begeleiding PLOH (BegeleidingPLOH)
        // Noodvoorziening (Noodvoorziening) -- Uit PLOH
        {
          key: 'UNIT.Kenmerk',
          label: 'Unit nr.',
        },
        {
          key: 'UNIT.Adres',
          label: 'Adres',
          thStyle: { 
            width: '150px' 
          }
        },
        {
          key: 'UNIT.Plaats',
          label: 'Plaats',
        },
        {
          key: 'UNIT.Onderhoud',
          label: 'Onderhoud',
        },
        {
          key: 'PREV.KEO',
          label: 'Prev. onderhoud',
        },
        {
          key: 'PREV.KRN',
          label: 'Keuringen',
        },
        {
          key: 'PREV.BEH',
          label: 'Beheerskosten',
        },
        {
          key: 'PREV.SPL',
          label: 'Spreekluister',
        },
        {
          key: 'PLOH.Total',
          label: 'Totaal PLOH',
        },
        {
          key: 'PLOH.COR',
          label: 'Reservering',
        },
        {
          key: 'PLOH.GSM',
          label: 'GSM Spreekluister',
        },
        {
          key: 'PLOH.BEH',
          label: 'Beg. PLOH',
        },
        {
          key: 'PLOH.NVZ',
          label: 'Noodvoorziening',
        },
      ]" 
      small
      striped
      bordered
    >
      <!--- templates for all but PLOH and PREV --->
      <template #cell(UNIT.Kenmerk)="data">
        <b>{{ data.value }}</b>
        <b-button 
          size="sm" 
          @click="updateUnit(data.item)"
        >
          Update
        </b-button>
      </template>
      <template #cell(UNIT.Adres)="data">
        <b>{{ data.value }}</b>
      </template>
      <template #cell(UNIT.Plaats)="data">
        <b>{{ data.value }}</b>
      </template>
      <template #cell(UNIT.Onderhoud)="data">
        <b>{{ data.value[0] }}</b>
      </template>

      <template #cell(PLOH.COR)="data">
        <FinancieelInput 
          :value="data.item.PLOH" 
          field="COR"
        />
      </template>

      <template #cell(PLOH.Total)="data">
        <FinancieelInput 
          :value="data.item.PLOH" 
          :disabled="true"
          field="Total"
        />
      </template>


      <template #cell(PLOH.BEH)="data">
        <FinancieelInput 
          :value="data.item.PLOH" 
          field="BEH"
        />
      </template>

      <template #cell(PLOH.NVZ)="data">
        <FinancieelInput 
          :value="data.item.PLOH" 
          :disabled="true" 
          field="NVZ"
        />
      </template>

      <template #cell(PLOH.GSM)="data">
        <FinancieelInput 
          :value="data.item.PLOH" 
          :disabled="true" 
          field="GSM"
        />
      </template>

      <template #cell(PREV.KRN)="data">
        <FinancieelInput 
          :value="data.item.PREV" 
          field="KRN"
        />
      </template>

      <template #cell(PREV.KEO)="data">
        <FinancieelInput 
          :value="data.item.PREV" 
          field="KEO"
        />
      </template>

      <template #cell(PREV.BEH)="data">
        <FinancieelInput 
          :value="data.item.PREV" 
          field="BEH"
        />
      </template>

      <template #cell(PREV.SPL)="data">
        <FinancieelInput 
          :value="data.item.PREV" 
          field="SPL"
        />
      </template>
    </b-table>
    <!-- <pre class="text-white">{{ units }}</pre>  -->
  </div>
</template>

<script>
import FinancieelInput from './FinancieelInput.vue';
import { serviceMixin } from '@/mixins/serviceMixin';

export default {
    name: 'UnitsFinancieel',
    components: {
      FinancieelInput
    },
    mixins: [
      serviceMixin
    ],
    props: {},
    data() {
        return  {
            // defaults voor tussen de relatie en de installeurs
            units: [
              
            ]
        }
    },
    computed: {
      api_path() {
        // /settings/relaties/4/units/financieel => /relaties/4/units/financieel
        return this.$route.path.replace('/settings', '');
      }
    },
    watch: {},
    mounted () {
      this.getUnits();
    },
    methods: {
      applyFilters() {
        // Implement filter logic here
      },
      getUnits() {
        this.get(this.api_path).then(
          response => {
            console.log(response.data);
            this.units = response.data.units;
          }
        );
      },
      updateUnit(postdata) {
        // Implement update logic here
        this.post(this.api_path, postdata).then(
          response => {
            console.log(response.data);
          }
        );
      }
    },
}
</script>

